import React, { useState } from 'react';
import EVTool from '../tools/EVTool';
import PFTool from '../tools/PFTool';
import EdgeTool from '../tools/EdgeTool';
import RuinTool from '../tools/RuinTool';
import MaxDDTool from '../tools/MaxDDTool';
import ConsLossTool from '../tools/ConsLossTool';
import MCEquityTool from '../tools/MCEquityTool';
import KellyTool from '../tools/KellyTool';
import FracTool from '../tools/FracTool';
import VolTool from '../tools/VolTool';
import SharpeTool from '../tools/SharpeTool';
import SortinoTool from '../tools/SortinoTool';
import CalmarTool from '../tools/CalmarTool';
import DistTool from '../tools/DistTool';
import CapTool from '../tools/CapTool';
import PlanTool from '../tools/PlanTool';
import CompTool from '../tools/CompTool';

const ToolsTab = () => {
    const [currentToolId, setCurrentToolId] = useState('ev');

    const tools = [
        { id: 'ev', name: '1. Expected Value', Component: EVTool },
        { id: 'pf', name: '2. Profit Factor', Component: PFTool },
        { id: 'edge', name: '3. Edge vs Market Range', Component: EdgeTool },
        { id: 'ruin', name: '4. Risk of Ruin', Component: RuinTool },
        { id: 'max_dd', name: '5. Max Drawdown Simulator', Component: MaxDDTool },
        { id: 'cons_loss', name: '6. Consecutive Loss Prob', Component: ConsLossTool },
        { id: 'mc_equity', name: '7. Monte Carlo Equity Sim', Component: MCEquityTool },
        { id: 'kelly', name: '8. Kelly Position Sizing', Component: KellyTool },
        { id: 'frac', name: '9. Fixed Fractional Sizing', Component: FracTool },
        { id: 'vol', name: '10. Volatility Sizing', Component: VolTool },
        { id: 'sharpe', name: '11. Sharpe Ratio Estimator', Component: SharpeTool },
        { id: 'sortino', name: '12. Sortino Ratio', Component: SortinoTool },
        { id: 'calmar', name: '13. Calmar Ratio', Component: CalmarTool },
        { id: 'dist', name: '14. Trade Distribution', Component: DistTool },
        { id: 'cap', name: '15. Range Capture', Component: CapTool },
        { id: 'plan', name: '16. Return Planning', Component: PlanTool },
        { id: 'comp', name: '17. Compounding Sim', Component: CompTool }
    ];

    const ActiveTool = tools.find(t => t.id === currentToolId)?.Component || EVTool;

    return (
        <div className="tct-container">
            <div className="tct-layout">
                <div className="tct-sidebar">
                    {tools.map(tool => (
                        <button 
                            key={tool.id} 
                            className={`tct-sidebar-btn ${currentToolId === tool.id ? 'active' : ''}`} 
                            onClick={() => setCurrentToolId(tool.id)}
                        >
                            {tool.name}
                        </button>
                    ))}
                </div>
                <div className="tct-content">
                    <ActiveTool />
                </div>
            </div>
        </div>
    );
};

export default ToolsTab;
